var isIE = /MSIE|Trident/.test(window.navigator.userAgent);

if (isIE) {
  window.location.replace('assets/static-templates/unsupported-browser.html');
}
